<template>
  <div data-server-rendered="true" id="__nuxt" class="bannerBox zqt-page">
    <!---->
    <div id="__layout">
      <div id="body">
        <div class="index_body">
          <div class="head_height">
            <div class="banner_box">
              <div class="banner page_width">
                <div class="ban_top">
                  <div class="logo"></div>
                  <div class="right flex">
                    <div class="no_login" v-if="!loginTrue" @click="loginUp()">
                      登录/注册
                    </div>
                    <!--                    <div class="no_loginLeft" @click="myInformation" v-else>-->
                    <!--                      <span>我的</span>-->
                    <!--                    </div>-->
                    <div class="no_loginRight" v-if="loginTrue">
                      <span class="logout" @click="logout" v-if="loginTrue"
                      >退出</span
                      >
                    </div>
                  </div>
                </div>
                <div class="ban_btn"></div>
              </div>
            </div>
          </div>

          <div class="bord" v-if="hisShow">
            <div>
              <div class="notice">该功能可以让科技工作者快速了解企业情况</div>

              <!--              <div v-for="(content, title) in text" :key="title" class="section">-->
              <!--                <h2 :class="title === '技术转移对接' ? 'highlight' : ''">{{ title }}</h2>-->
              <!--                <p>{{ content }}</p>-->
              <!--              </div>-->

              <!--加载中的遮罩-->
              <div v-if="isLoading">
                <div class="loadingGif fade-in">
                  <loading/>
                  <div style="margin-top: 16px;font-size: 20px">报告生成中...</div>
                  <div style="margin-top: 16px;font-size: 20px">该模型包含数据查询、复杂逻辑推导、界面图形生成，请耐心等待1-2分钟</div>
                </div>
              </div>
              <!---生成公司信息-->
              <div id="app" v-if="textShow && !isLoading">
                <h1 style="margin-right: 10px;text-align: left" v-if="textShow &&  !isLoading" >企业信息：</h1>
                <AdaptiveIframe
                    :src="htmlUrl"
                    custom-class="concept-iframe"
                    :min-height="500"
                    :height-margin="0"
                    :retry-count="1"
                    :retry-interval="1000"
                />
                <div class="containerDic" >
              <span class="containerSpan" v-if="textShow &&  !isLoading">
                {{ companyName + "行业知识图谱：" }}
              </span>
                </div>
                <div class="containerHy" v-show="!isLoading">
                  <div id="containerHy" class="graph-container"></div>
                  <div v-if="!textShow" class="loading">
                    <div class="spinner"></div>
                    <p>数据正在生成中，请耐心等待......</p>
                  </div>
                </div>

                <div class="containerDownDiv">
              <span class="containerDownSpan" v-if="textShow &&  !isLoading" >
                {{ companyName + "技术知识图谱：" }}
              </span>
                </div>
                <div class="containerDown">
                  <div id="containerDown" class="graph-container"></div>
                  <!--              <div class="textClass" v-html="textDetail"></div>-->
                </div>
                <div>
                  <h1 style="margin-right: 10px;text-align: left" v-if="textShow &&  !isLoading">行业分析：</h1>
                  <div id="app" v-if="textShow">
                    <AdaptiveIframe
                        :src="htmlUrlNew"
                        custom-class="concept-iframe"
                        :min-height="500"
                        :height-margin="0"
                        :retry-count="1"
                        :retry-interval="1000"
                    />
                  </div>
                </div>
              </div>

              <div class="zqt-dashboard" v-if="!isLoading && !textShow">
                <div class="zqt-stats">
                  <div class="zqt-stat">
                    <div class="zqt-stat-value">18.7K+</div>
                    <div class="zqt-stat-label">企业数据库</div>
                  </div>
                  <div class="zqt-stat">
                    <div class="zqt-stat-value">3.2K+</div>
                    <div class="zqt-stat-label">科技成果</div>
                  </div>
                  <div class="zqt-stat">
                    <div class="zqt-stat-value">¥8.7亿</div>
                    <div class="zqt-stat-label">转化金额</div>
                  </div>
                  <div class="zqt-stat">
                    <div class="zqt-stat-value">94%</div>
                    <div class="zqt-stat-label">匹配准确率</div>
                  </div>
                </div>

                <div class="zqt-section-title">
                  <div class="zqt-section-title-text">核心功能系统</div>
                  <div class="zqt-section-title-line"></div>
                </div>

                <div class="zqt-cards">
                  <div class="zqt-card">
                    <div class="zqt-card-icon">
                      <i class="el-icon-office-building"></i>
                    </div>
                    <div class="zqt-card-title">企业智能透视系统</div>
                    <div class="zqt-card-desc">基于AI的企业技术画像分析，实时评估创新能力、产业链定位与技术优势，提供精准的成果对接与合作伙伴匹配。</div>
                    <div class="zqt-card-metrics">
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">18,742</div>
                        <div class="zqt-metric-label">企业数据</div>
                      </div>
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">94%</div>
                        <div class="zqt-metric-label">分析准确率</div>
                      </div>
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">实时</div>
                        <div class="zqt-metric-label">数据更新</div>
                      </div>
                    </div>
                  </div>

                  <div class="zqt-card">
                    <div class="zqt-card-icon">
                      <i class="el-icon-sort"></i>
                    </div>
                    <div class="zqt-card-title">成果转化对接平台</div>
                    <div class="zqt-card-desc">智能匹配技术供需，构建技术转移生态，促进科技成果高效流转，实现产学研协同创新与产业链对接。</div>
                    <div class="zqt-card-metrics">
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">3,285</div>
                        <div class="zqt-metric-label">转化成果</div>
                      </div>
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">72%</div>
                        <div class="zqt-metric-label">匹配成功率</div>
                      </div>
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">897</div>
                        <div class="zqt-metric-label">成功案例</div>
                      </div>
                    </div>
                  </div>

                  <div class="zqt-card">
                    <div class="zqt-card-icon">
                      <i class="el-icon-data-analysis"></i>
                    </div>
                    <div class="zqt-card-title">产业大脑数据分析</div>
                    <div class="zqt-card-desc">实时整合多维度数据，技术趋势洞察、竞品分析与招投标情报，构建产业知识图谱，为企业决策提供数据支撑。</div>
                    <div class="zqt-card-metrics">
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">256TB</div>
                        <div class="zqt-metric-label">产业数据</div>
                      </div>
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">15+</div>
                        <div class="zqt-metric-label">分析维度</div>
                      </div>
                      <div class="zqt-metric">
                        <div class="zqt-metric-value">实时</div>
                        <div class="zqt-metric-label">趋势洞察</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="zqt-search">
                  <div class="zqt-search-title">智能分析与匹配</div>
                  <div class="zqt-search-subtitle">输入企业或技术关键词，获取智能分析报告与潜在合作机会</div>

                  <div class="zqt-search-form">
                    <div class="zqt-field">
                      <div class="zqt-field-label">
                        <i class="el-icon-edit"></i>
                        <span>请输入企业/机构名称</span>
                      </div>
                      <el-input
                          placeholder="输入名称获取智能分析报告..."
                          clearable
                          v-model="companyName"
                      />
                    </div>

                    <!-- <div class="zqt-field">
                      <div class="zqt-field-label">
                        <i class="el-icon-search"></i>
                        <span>或输入技术关键词/需求</span>
                      </div>
                      <el-input
                          placeholder="输入技术关键词发现潜在合作机会..."
                          clearable
                          v-model="techKeyword"
                      />
                    </div> -->

                    <el-button class="zqt-search-btn" type="primary" @click="queryKnowledge">
                      智能分析与匹配
                    </el-button>
<!--
                    <div class="zqt-actions">
                      <el-button class="zqt-action" plain size="mini">语音输入</el-button>
                      <el-button class="zqt-action" plain size="mini">上传文件分析</el-button>
                      <el-button class="zqt-action" plain size="mini">行业数据报告</el-button>
                      <el-button class="zqt-action" plain size="mini">AI智能推荐</el-button>
                    </div> -->
                  </div>
                </div>

                <!-- <div class="zqt-section-title zqt-section-title--mt">
                  <div class="zqt-section-title-text">平台数据总览</div>
                  <div class="zqt-section-title-line"></div>
                </div> -->

                <!-- 新增：典型应用场景 -->
                <div class="zqt-section-title zqt-section-title--mt">
                  <div class="zqt-section-title-text">典型应用场景</div>
                  <div class="zqt-section-title-line"></div>
                </div>

                <div class="zqt-scenarios">
                  <div class="zqt-scenario-card">
                    <div class="zqt-scenario-tag">政府与园区管理</div>
                    <div class="zqt-scenario-title">区域产业画像与资源配置</div>
                    <div class="zqt-scenario-desc">
                      通过企业与科技成果知识图谱，快速梳理本地区重点产业、龙头企业与配套企业分布，
                      支撑“专精特新”企业培育、产业集群规划与招商引资决策。
                    </div>
                    <ul class="zqt-scenario-list">
                      <li>一图掌握区域产业链上下游结构</li>
                      <li>识别产业短板与补链延链机会</li>
                      <li>辅助制定科技创新与产业扶持政策</li>
                    </ul>
                  </div>

                  <div class="zqt-scenario-card">
                    <div class="zqt-scenario-tag">高校与科研机构</div>
                    <div class="zqt-scenario-title">成果转化与企校对接</div>
                    <div class="zqt-scenario-desc">
                      将高校科研成果与企业技术需求进行智能匹配，帮助科研团队找到最适合的应用场景与合作伙伴，
                      缩短成果从“论文”到“项目”的转化周期。
                    </div>
                    <ul class="zqt-scenario-list">
                      <li>科技成果与产业需求双向检索</li>
                      <li>智能推荐潜在合作企业与试点场景</li>
                      <li>沉淀可视化成果转化案例库</li>
                    </ul>
                  </div>

                  <div class="zqt-scenario-card">
                    <div class="zqt-scenario-tag">企业与科技服务机构</div>
                    <div class="zqt-scenario-title">技术升级与创新决策辅助</div>
                    <div class="zqt-scenario-desc">
                      面向企业技术负责人与咨询服务机构，提供竞品分析、技术发展路径与合作高校推荐，
                      帮助企业精准识别“该投什么、跟谁投、在哪投”。
                    </div>
                    <ul class="zqt-scenario-list">
                      <li>企业技术画像与竞品对比分析</li>
                      <li>细分领域技术趋势研判</li>
                      <li>智能生成科创决策辅助报告</li>
                    </ul>
                  </div>
                </div>

                <!-- 新增：服务流程 -->
                <div class="zqt-section-title zqt-section-title--mt">
                  <div class="zqt-section-title-text">服务流程一目了然</div>
                  <div class="zqt-section-title-line"></div>
                </div>

                <div class="zqt-flow">
                  <div class="zqt-flow-step">
                    <div class="zqt-flow-icon">1</div>
                    <div class="zqt-flow-title">提交企业/机构名称</div>
                    <div class="zqt-flow-desc">
                      在上方输入框中填写目标企业或机构名称，
                      系统将自动联动企业基础信息与公开数据源。
                    </div>
                  </div>
                  <div class="zqt-flow-arrow"></div>
                  <div class="zqt-flow-step">
                    <div class="zqt-flow-icon">2</div>
                    <div class="zqt-flow-title">生成科创全景画像</div>
                    <div class="zqt-flow-desc">
                      自动生成企业业务概况、行业地位、掌握技术、知识产权分布及科创评分等多维度分析报告。
                    </div>
                  </div>
                  <div class="zqt-flow-arrow"></div>
                  <div class="zqt-flow-step">
                    <div class="zqt-flow-icon">3</div>
                    <div class="zqt-flow-title">构建产业与技术图谱</div>
                    <div class="zqt-flow-desc">
                      同步生成行业知识图谱、技术知识图谱，直观展示上下游关系与关键技术节点。
                    </div>
                  </div>
                  <div class="zqt-flow-arrow"></div>
                  <div class="zqt-flow-step">
                    <div class="zqt-flow-icon">4</div>
                    <div class="zqt-flow-title">发现合作机会</div>
                    <div class="zqt-flow-desc">
                      结合高校院所、科研平台与龙头企业信息，辅助寻找技术转移、成果转化与联合攻关机会。
                    </div>
                  </div>
                </div>

                <!-- 新增：数据安全与合规说明 -->
                <div class="zqt-section-title zqt-section-title--mt">
                  <div class="zqt-section-title-text">数据安全与合规说明</div>
                  <div class="zqt-section-title-line"></div>
                </div>

                <div class="zqt-security">
                  <div class="zqt-security-item">
                    <div class="zqt-security-title">公开数据来源</div>
                    <div class="zqt-security-desc">
                      系统优先基于政府公示信息、权威统计数据及依法依规公开的企业信息进行综合分析，
                      不采集、不展示用户未授权的敏感数据。
                    </div>
                  </div>
                  <div class="zqt-security-item">
                    <div class="zqt-security-title">隐私保护机制</div>
                    <div class="zqt-security-desc">
                      对查询记录进行脱敏与聚合处理，仅用于模型优化与服务质量提升，
                      不对外展示单个用户的查询行为与个体隐私信息。
                    </div>
                  </div>
                  <div class="zqt-security-item">
                    <div class="zqt-security-title">结果仅供参考</div>
                    <div class="zqt-security-desc">
                      平台基于大模型综合研判生成报告，部分数据可能存在更新滞后或不完全情况，
                      所有分析结论仅作为决策辅助，不构成正式法律或投资意见。
                    </div>
                  </div>
                </div>
              </div>
              <el-button
                  v-if="textShow"
                  class="queryButton"
                  type="primary"
                  @click="changeStatus()"
              >
                重新查询
              </el-button>
            </div>
          </div>
          <!---下面背景图 -->
          <div style="background: #252525">
            <img
                src="../assets/img/c02ddf2d50ba0a9c37c54f6b278d02a.png"
                alt
                class="foot_bg"
            />
            <div class="website">
              <div class="max_wid">
                <div class="max_lef">
                  <!--                  <div class="labe2">版权所有：泰安市科学技术局</div>-->
                  <div class="labe2">
                    通讯地址：泰安市高新区正阳门大街28号国家高创中心西塔422号
                  </div>
                  <div class="classLabe2">
                    <div class="labe2Left">
                      主办单位：泰山科技大市场
                      <span class="view-count-inline">
                        <i class="el-icon-view"></i>
                        <span>{{ viewCount }} 浏览</span>
                      </span>
                    </div>
                    <div class="labe2Right">技术支持：0538-8265266</div>
                  </div>
                </div>
                <div class="max_rig">
                  <!--              <div class="label">服务电话：</div>-->
                  <div class="labe2">联系方式：18953878448</div>
                  <div class="labe2">邮编：271000</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import PersonalInformation from "./PersonalInformation .vue";
import InformationAdmin from "@/views/InformationAdmin.vue";
import PersonalFrom from "@/views/PersonalFrom.vue";
import unionFrom from "@/views/unionFrom.vue";
import HistoricalRecords from "@/views/historicalRecords.vue";
import {artificialIntelligence, derivativeDiagram, derivativeDiagramDown, getToken, visit} from "@/api/http";
import {changeStatus} from "@/api/login";
import loading from "@/components/loading.vue";
import {getHtml, addZhiQiTongRecord, editZhiQiTongRecord} from "@/api/concept";
import AdaptiveIframe from "@/components/AdaptiveIframe.vue";
import axios from "axios";

import * as echarts from "echarts/core"; // 核心库
// 按需引入你需要的组件
import {
  TooltipComponent, // 提示框组件
  LegendComponent, // 图例组件
  GridComponent, // 网格组件（如果使用直角坐标系）
} from "echarts/components";

// 引入你需要的图表类型
import {
  PieChart, // 饼图
  RadarChart, // 雷达图
  BarChart, // 柱状图（如果需要）
} from "echarts/charts";

// 引入渲染器
import {CanvasRenderer} from "echarts/renderers";
// 方式 2：在顶部 import
import {Graph, treeToGraphData} from "@antv/g6";
// 注册你需要的组件
echarts.use([
  TooltipComponent,
  LegendComponent,
  GridComponent,
  PieChart,
  RadarChart,
  BarChart,
  CanvasRenderer,
]);

// 现在你可以在任何地方使用 echarts 了
// const echarts = require('echarts/lib/echarts');
// require('echarts/lib/component/title');
// require('echarts/lib/component/legend');
// require('echarts/lib/chart/radar');

export default {
  components: {
    HistoricalRecords,
    PersonalFrom,
    unionFrom,
    xinxi: PersonalInformation,
    InformationAdmin,
    loading,
    AdaptiveIframe,
  },
  data() {
    return {
      viewCount: 0,
      outputOne: "",
      outputTwo: "",
      outputThree: "",
      outputFour: "",
      outputFive: "",
      outputSix: "",
      outputSeven: "",
      outputOneShow: false,
      outputTwoShow: false,
      outputThreeShow: false,
      outputFourShow: false,
      outputFiveShow: false,
      techQuality: 0,
      techScale: 0,
      researchStrength: 0,
      growthPotential: 0,
      industryPotential: 0,

      rawData: "", // 用于存储从API获取的完整数据
      parts: [], // 用于逐步显示的数据
      //展示数据
      textShow: false,
      //加载中
      isLoading: false,
      hisShow: true,
      loginTrue: "", //是否登录
      companyName: "",
      techKeyword: "",
      // text: "{\n    1. **企业概况**：\n        - 石横特钢集团有限公司（简称“石横特钢”）是一家集焦化、炼铁、炼钢、轧钢、发电、机械制造、民间资本、钢铁物流于一体的大型钢铁联合企业，总部位于泰安肥城市石横镇。\n        - 公司主营业务涵盖钢铁生产及其相关领域，产品体系完备，包括建筑钢材、板材、矿用支护用钢、电力角钢等专业领域产品，以及高强度合金钢、耐蚀钢、耐低温钢等发展方向产品。\n\n    2. **行业地位**：\n        - 石横特钢综合经济实力连续多年跻身中国企业500强、中国企业集团纳税500强之列。\n        - 公司被工信部认定为绿色工厂，被科技部认定为高新技术企业，在中国钢铁企业综合竞争力评级中连续多年获评特强A级。\n        - 石横特钢还荣获了国家智能制造示范工厂、国家企业技术中心、山东省和谐劳动关系优秀企业、山东省节能先进企业、山东省循环经济示范企业等一系列荣誉称号。\n\n    3. **掌握技术**：\n        - 石横特钢拥有先进的钢铁生产技术，包括高炉炼铁、转炉炼钢、轧钢等生产线，以及从美国摩根公司和意大利引进的先进生产线。\n        - 公司在生产过程中注重技术创新和精细化管理，不断提升产品质量和生产效率。\n        - 公司在环保方面也取得了显著成果，如采用先进的废气治理设施和水循环利用系统，实现了固体废物100%综合利用合规处置，水循环利用率达到97.5%以上。\n\n    4. **知识产权**：\n        - 实时搜索查询显示，石横特钢拥有一定数量的专利和软件著作权。但具体数量可能因时间变化而有所不同，建议直接访问国家知识产权局官网或公司官网进行查询。\n\n    5. **科创评分**：\n        - 从技术质量来看，石横特钢的产品质量稳定，多次获得国家和省级荣誉，可以给予18分。\n        - 从技术规模来看，公司拥有完整的钢铁生产流程和先进的生产设备，规模较大，给予19分。\n        - 从研发实力来看，公司注重技术创新和研发投入，拥有多项专利和荣誉，给予18分。\n        - 从成长性来看，公司连续多年保持稳健发展，综合实力不断提升，给予17分。\n        - 从行业潜力来看，钢铁行业仍有发展空间，且石横特钢在行业内处于领先地位，给予16分。\n        - 总分：18+19+18+17+16=98分，评级别为A级（优秀）。\n\n    6. **行业发展方向**：\n        - 石横特钢应继续加强在优质精品钢生产领域的投入，提升产品附加值和市场竞争力。\n        - 拓展新能源和环保产业，如利用余热发电、开发低碳排放技术等，以适应国家绿色发展的要求。\n        - 深化数字化转型，提升生产效率和智能化水平，降低运营成本。\n\n    7. **技术需求挖掘**：\n        - 在产业升级方面，石横特钢需要引进更先进的生产技术和管理模式，提升产品质量和生产效率。\n        - 在降低成本方面，公司需要研发更高效的能源利用技术和废弃物回收技术，降低生产成本和环境负担。\n        - 具有前瞻性的创新技术需求包括开发新型高性能钢材、优化生产工艺流程、提升智能化和自动化水平等。\n\n    8. **技术转移对接**：\n        - 对于先进的生产技术和管理模式，石横特钢可以与国内外知名的钢铁企业和研究机构进行合作，引进先进技术和管理经验。\n        - 在新能源和环保技术方面，可以与山东省内重点高校如山东大学、中国海洋大学等进行合作研发。\n        - 在数字化转型方面，可以与山东省内的IT企业和研究机构进行合作，共同开发适用于钢铁行业的智能化和自动化技术。\n}\n\n以上信息仅供参考，如需更详细和准确的信息，建议直接访问石横特钢集团有限公司的官网或联系公司相关部门。}",
      text: "",
      keywords: ["企业概况"],
      output: "",
      token: "",
      pieData: [],
      htmlUrlNew: "",
      png1: "",
      png2: '',
      htmlUrl: "",
    };
  },


  mounted() {
    this.initViewCount();
    document.addEventListener("keydown", function (e) {
      // 禁止 F12（开发者工具）
      if (e.keyCode === 123) {
        e.preventDefault();
      }
      // 禁止 Ctrl+Shift+I（开发者工具）
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
      }
      // 禁止 Ctrl+Shift+J（控制台）
      if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
        e.preventDefault();
      }
    });
  },
  created() {
    this.getToken();
    console.log("localStorage.getItem('token')", localStorage.getItem("token"));
    this.login();
    this.getTokeNew();
  },

  methods: {
    async initViewCount() {
      const pageKey = this.$route?.path || 'ZhiqiTong';
      try {
        const res = await visit({ pageKey });
        const data = res && res.data !== undefined ? res.data : res;
        if (data && (data.code === 200 || data.code === 0)) {
          this.viewCount = data.data;
        } else if (typeof data === 'number') {
          this.viewCount = data;
        } else if (data && typeof data.data === 'number') {
          this.viewCount = data.data;
        }
      } catch (e) {
        console.error('浏览量上报失败', e);
      }
    },
    getChartDom() {
      const chartDom = document.getElementById("chart-container");
      // 1. 加强DOM元素检查
      if (!chartDom) {
        console.error("找不到chart-container元素");
        return null;
      }

      // 2. 安全销毁旧实例
      const oldChart = echarts.getInstanceByDom(chartDom);
      if (oldChart && !oldChart.isDisposed()) {
        oldChart.dispose();
      }

      // 3. 初始化新实例
      const myChart = echarts.init(chartDom);

      // 4. 准备配置项
      const option = {
        color: ["#67abf9", "#FFE434", "#56A3F1", "#FF917C"],
        title: {},
        legend: {show: false},
        radar: [
          {
            indicator: [
              {text: "技术质量"},
              {text: "技术规模"},
              {text: "研发实力"},
              {text: "成长性"},
              {text: "行业潜力"},
            ],

            center: ["100%"], // 修改为居中
            // center: ['100%'],
            radius: 50,
            startAngle: 90,
            splitNumber: 5,
            shape: "circle",
            axisName: {
              formatter: "【{value}】",
              color: "#428BD4",
            },
            splitArea: {
              areaStyle: {
                color: ["#77b1ea", "#26C3BE", "#64AFE9", "#428BD4"],
                shadowColor: "rgba(0, 0, 0, 0.2)",
                shadowBlur: 10,
              },
            },
            axisLine: {
              lineStyle: {
                color: "rgba(211, 253, 250, 0.8)",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(211, 253, 250, 0.8)",
              },
            },
          },
          {
            indicator: [
              {text: "技术质量", max: 5},
              {text: "技术规模", max: 5},
              {text: "研发实力", max: 5},
              {text: "成长性", max: 5},
              {text: "行业潜力", max: 5},
            ],
            center: ["50%", "50%"],
            radius: 120,
            axisName: {
              color: "#fff",
              backgroundColor: "#666",
              borderRadius: 3,
              padding: [3, 5],
            },
          },
        ],
        series: [
          {
            type: "radar",
            emphasis: {
              lineStyle: {
                width: 4,
              },
            },
            data: [
              {
                value: [
                  this.techQuality,
                  this.techScale,
                  this.researchStrength,
                  this.growthPotential,
                  this.industryPotential,
                ],
                // name: '技术质量'
              },
              {
                value: [
                  this.techQuality,
                  this.techScale,
                  this.researchStrength,
                  this.growthPotential,
                  this.industryPotential,
                ],
                // name: '技术规模',
                areaStyle: {
                  color: "rgb(0,119,255)",
                },
              },
            ],
          },
          {
            type: "radar",
            radarIndex: 1,
            data: [
              {
                value: [
                  this.techQuality,
                  this.techScale,
                  this.researchStrength,
                  this.growthPotential,
                  this.industryPotential,
                ],
                name: "研发实力",
                symbol: "rect",
                symbolSize: 12,
                lineStyle: {
                  type: "dashed",
                },
                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value;
                  },
                },
              },
              {
                value: [
                  this.techQuality,
                  this.techScale,
                  this.researchStrength,
                  this.growthPotential,
                  this.industryPotential,
                ],
                name: "成长性",
                symbol: "rect",
                symbolSize: 12,
                lineStyle: {
                  type: "dashed",
                },
                label: {
                  show: true,
                  formatter: function (params) {
                    return params.value;
                  },
                },
              },
              {
                value: [
                  this.techQuality,
                  this.techScale,
                  this.researchStrength,
                  this.growthPotential,
                  this.industryPotential,
                ],
                name: "行业潜力",
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: "rgba(255, 145, 124, 0.1)",
                      offset: 0,
                    },
                    {
                      color: "rgba(255, 145, 124, 0.9)",
                      offset: 1,
                    },
                  ]),
                },
              },
            ],
          },
        ],
      };

      // 5. 安全设置选项
      try {
        myChart.setOption(option);
      } catch (e) {
        console.error("图表配置失败:", e);
        if (!myChart.isDisposed()) {
          myChart.dispose();
        }
        return null;
      }

      // 6. 添加响应式处理
      const resizeHandler = () => {
        if (!myChart.isDisposed()) {
          myChart.resize();
        }
      };
      window.addEventListener("resize", resizeHandler);

      // 7. 返回实例和清理函数
      return {
        instance: myChart,
        dispose: () => {
          window.removeEventListener("resize", resizeHandler);
          if (!myChart.isDisposed()) {
            myChart.dispose();
          }
        },
      };
    },

    //饼状图

    getPieChart() {
      const chartDom = document.getElementById("pieChart");

      // 修正1：这里应该使用chartDom而不是未定义的domElement
      let oldChart = echarts.getInstanceByDom(chartDom);

      // 如果存在则先销毁
      if (oldChart) {
        oldChart.dispose();
      }

      // 修正2：添加DOM元素存在性检查
      if (!chartDom) {
        console.error("找不到pieChart元素");
        return;
      }

      const myChart = echarts.init(chartDom);

      // 修正3：简化option声明
      const option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },

        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10,
            },
            label: {
              show: false,
              position: "center",
            },

            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.pieData,
          },
        ],
      };

      // 修正4：移除不必要的条件判断
      myChart.setOption(option);

      // 修正5：添加窗口resize事件处理
      window.addEventListener("resize", function () {
        myChart.resize();
      });

      // 返回chart实例以便后续操作
      return myChart;
    },

    async getProblem() {
      let text =
          ' "你是一个负责科技成果创新转移转化的技术经理人。\\n" +\n"请全网实时搜索，并且结合企查查和政府公开数据' +
          this.companyName +
          '相关资料和信息,请以序号加标题，不要展示标题,格式返回给我，\\n" +';
      const problemList = [
        {
          id: "1",
          problemText: "企业概况：整理总结下该公司目前的主营业务或主要产品。",
        },
        {
          id: "2",
          // problemText: "知识产权：实时搜索查询，并结合企查查和政府官网公示的数据,查询一下 " + this.companyName + " 的专利、商标和软件著作权（如果没有搜索到可以使用接近的数量代替）分别多少( 注：需要展示具体的数量，如果没有搜索到可以使用接近的数量代替,不要出现企查查等字眼，要出现具体数量，不要出现替代符xxx之类的东西)。"
          problemText:
              "知识产权：请使用实时搜索查询，结合企查查和政局官网公示的数据，即时搜索目前拥有的专利、商标和软件著作权数量。请提供具体的数字，如果未搜到，可以使用相近的数字代替。请注意，提供数字时请使用简洁明了的表达方式，",
        },

        {
          id: "3",
          problemText: "掌握技术：企业目前拥有的技术都有哪些，请列举描述。",
        },
        // {
        //   id: "4",
        //   // problemText: "知识产权：实时搜索查询，并结合企查查和政府官网公示的数据,查询一下 " + this.companyName + " 的专利、商标和软件著作权（如果没有搜索到可以使用接近的数量代替）分别多少( 注：需要展示具体的数量，如果没有搜索到可以使用接近的数量代替,不要出现企查查等字眼，要出现具体数量，不要出现替代符xxx之类的东西)。"
        //   problemText: "知识产权：请使用实时搜索查询，结合企查查和政局官网公示的数据，即时搜索\"泰安奇蚁科技\"目前拥有的专利、商标和软件著作权数量。请提供具体的数字，如果未搜到，可以使用相近的数字代替。请注意，提供数字时请使用简洁明了的表达方式，"
        // },
        {
          id: "4",
          problemText:
              "行业地位：判断下企业当前经营情况，在该行业内的处于什么层次和地位，详细列下获得了哪些荣誉。",
        },
        {
          id: "5",
          problemText:
              "科创评分：从技术质量、技术规模、研发实力、成长性、行业潜力这五个方向评级，评级标准为：A非常好，B好，C一般，D差。并注明，（以上评级结果来源于大模型评估，不具有参考价值,并且显示出评级标准为：A非常好，B好，C一般，D差。)",
        },
      ];
      //评分雷达图
      this.getArtificialIntelligence();
      //软著饼图
      this.getScore();
      for (const item of problemList) {
        console.log(`ID: ${item.id}, 问题: ${item.problemText}`);
        this.textShow = true;
        if (item.id === "1") {
          await this.fetchStreamData(item.id, text + item.problemText);
        } else if (item.id === "2") {
          this.outputTwoShow = true;
          this.getPieChart();
          await this.fetchStreamData(item.id, text + item.problemText);
        } else if (item.id === "3") {
          this.outputThreeShow = true;
          await this.fetchStreamData(item.id, text + item.problemText);
        } else if (item.id === "4") {
          this.outputFourShow = true;
          await this.fetchStreamData(item.id, text + item.problemText);
        } else if (item.id === "5") {
          this.outputFiveShow = true;
          this.getChartDom();
          await this.fetchStreamData(item.id, text + item.problemText);
        }
      }
    },
    // getToken(){
    //
    // }
    //软著
    getArtificialIntelligence() {
      const text =
          "请使用实时搜索查询，结合企查查和政局官网公示的数据，即时搜索" +
          this.companyName +
          '目前拥有的专利、商标和软件著作权数量。请提供具体的数字，如果未搜到，' +
          '可以使用相近的数字代替。请注意，提供数字时请使用简洁明了的表达方式，' +
          '只需要返回给我数字，不要有多余得中文解释，请不要返回**注意**等字眼，' +
          '只需要一个json数据，也不要出现假设值得字段，避免使用“未知”、“解释”、“注意”等字眼，' +
          '并返回一个JSON格式的结果，不要给我返回中文汉字，，' +
          '如下所示：[{"value": 60, "name": "知识产权"}, {"value": 10, "name": "专利"}, ' +
          '{"value": 30, "name": "商标"}]';
      const encodedText = encodeURIComponent(text);
      artificialIntelligence(JSON.stringify(encodedText)).then((res) => {
        let start = res.data.indexOf("[");
        let end = res.data.indexOf("]") + 1;
        // 提取 JSON 部分
        let jsonData = res.data.substring(start, end);
        let json = JSON.parse(jsonData);
        console.log("json", json);
        this.pieData = json;
      });
    },

    //软著
    getScore() {
      const text =
          "科创评分：从技术质量、技术规模、研发实力、成长性、行业潜力这五个方向评级，评级标准为：A非常好，B好，C一般，D差。并注明，（以上评级结果来源于大模型评估，不具有参考价值,并且显示出评级标准为：分数（满分5分）)，请给我一个json数据，不需要评分标准、需要给我一个整数得分、不要有备注，也不要有（）里面的内容，不需要等级只需要给我评分";
      const encodedText = encodeURIComponent(text);
      artificialIntelligence(JSON.stringify(encodedText)).then((res) => {
        let obj = JSON.parse(res.data); // 解析 JSON 字符串
        let scores = obj["科创评分"]; // 获取 "科创评分" 对象
        this.techQuality = scores["技术质量"];
        this.techScale = scores["技术规模"];
        this.researchStrength = scores["研发实力"];
        this.growthPotential = scores["成长性"];
        this.industryPotential = scores["行业潜力"];
        console.log("res", res);
        console.log("this.techQuality", this.techQuality);
        console.log("this.techScale", this.techScale);
        console.log("this.researchStrength", this.researchStrength);
        console.log("this.growthPotential", this.growthPotential);
        console.log("this.industryPotential", this.industryPotential);
      });
    },

    getTokeNew() {
      getToken().then((response) => {
        console.log("e", response.data);
        this.token = response.data;
      });
    },

    async fetchStreamData(id, text) {
      document.addEventListener("keydown", function (e) {
        // 禁止 F12（开发者工具）
        if (e.keyCode === 123) {
          e.preventDefault();
        }
        // 禁止 Ctrl+Shift+I（开发者工具）
        if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
          e.preventDefault();
        }
        // 禁止 Ctrl+Shift+J（控制台）
        if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
          e.preventDefault();
        }
      });
      console.log();
      if (this.token == null) {
        this.getTokeNew();
      }

      console.log("token", this.token);
      const url =
          `https://aip.baidubce.com/rpc/2.0/ai_custom/v1/wenxinworkshop/chat/ernie-3.5-128k?access_token=` +
          this.token;
      const body = JSON.stringify({
        enable_trace: true,
        response_format: "json_object",
        disable_search: false,
        stream: true,
        messages: [
          {
            role: "user",
            content: "\n" + text,
            // "你是一个负责科技成果创新转移转化的技术经理人。\n" +
            // "请全网实时搜索，并且结合企查查和政府公开数据。" + this.companyName + "相关资料和信息,请以序号加标题，不要展示标题,格式返回给我，\n" +
            // "1、企业概况：整理总结下该公司目前的主营业务或主要产品。\n" +
            // "2、行业地位：判断下企业当前经营情况，在该行业内的处于什么层次和地位，详细列下获得了哪些荣誉。\n" +
            // "3、掌握技术：企业目前拥有的技术都有哪些，请列举描述。\n" +
            // "4、知识产权：实时搜索查询，并结合企查查和政府官网公示的数据,查询一下 " + this.companyName + " 目前拥有的专利和软件著作权数量（如果没有搜索到可以使用接近的数量代替）分别多少( 注：需要展示具体的数量，如果没有搜索到可以使用接近的数量代替,不要出现企查查等字眼，要出现具体数量，不要出现替代符xxx之类的东西)。\n" +
            // "5、科创评分：从技术质量、技术规模、研发实力、成长性、行业潜力这五个方向评级，评级标准为：A非常好，B好，C一般，D差。并注明，（以上评级结果来源于大模型评估，不具有参考价值,并且显示出评级标准为：A非常好，B好，C一般，D差。）\n" +
            // "6、行业发展方向：企业要生存发展壮大的话，这些业务和产品未来发展有哪些好的方向，请详细列举和描述。\n" +
            // "7、技术需求挖掘：这些业务和产品要进行产业升级或降低成本来获得更好的市场份额和企业利润，那么企业有哪些技术需求，具有前瞻性的创新技性术需求目前都有哪些？请详细列举和描述。\n" +
            // "8、技术转移对接：如果企业需要对接拥有这些技术的团队，那这些技术分别对应哪些拥有这些技术的高校科研院所或企业，优先是省内重点高校也可以补充下当地的高校（要出现具体的大学名字），请详细列举和描述 。注：：一定要具体的数据，不要出现x或者替代符。" + "注：一定要具体的数据，不要出现xxx或者替代符"
          },
        ], // 你要传递的 body 参数
      });

      const response = await fetch(url, {
        method: "POST", // 使用 POST 请求
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer 24.b35493e3d23ccfadb6172f3ffaa55b63.2592000.1739064173.282335-116973795`,
        },
        body: body, // 传递请求体
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let done = false;
      let chunk = "";
      // 使用循环从流中读取数据
      while (!done) {
        const {value, done: doneReading} = await reader.read();
        done = doneReading;
        // // 将当前读取的数据块解码为文本
        chunk = decoder.decode(value, {stream: true});
        // 逐步更新页面内容
        const jsonMatches = chunk.match(/\{.*}/g); // 匹配所有有效的 JSON 字符串部分
        if (jsonMatches) {
          // 如果找到了有效的 JSON 部分，逐个解析
          jsonMatches.forEach((item) => {
            try {
              const parsedData = JSON.parse(item); // 解析 JSON
              if (parsedData.result) {
                console.log("id", id);
                if (id === "1") {
                  this.outputOne += parsedData.result
                      .replace(/[{}]/g, "")
                      .replace(/\*\*/g, "")
                      .replace(/['[]']/g, "")
                      .replace(/,/g, "")
                      .replace(/''/g, "")
                      .replace(/"/g, "");
                  // 追加 result 到 output
                } else if (id === "2") {
                  this.outputTwoShow = true;
                  this.outputTwo += parsedData.result
                      .replace(/[{}]/g, "")
                      .replace(/\*\*/g, "")
                      .replace(/['[]']/g, "")
                      .replace(/,/g, "")
                      .replace(/''/g, "")
                      .replace(/"/g, "")
                      .replace("企查查", ""); // 追加 result 到 output
                } else if (id === "3") {
                  this.outputThreeShow = true;
                  this.outputThree += parsedData.result
                      .replace(/[{}]/g, "")
                      .replace(/\*\*/g, "")
                      .replace(/['[]']/g, "")
                      .replace(/,/g, "")
                      .replace(/''/g, "")
                      .replace(/"/g, ""); // 追加 result 到 output
                } else if (id === "4") {
                  this.outputFourShow = true;
                  this.outputFour += parsedData.result
                      .replace(/[{}]/g, "")
                      .replace(/\*\*/g, "")
                      .replace(/['[]']/g, "")
                      .replace(/,/g, "")
                      .replace(/''/g, "")
                      .replace(/"/g, ""); // 追加 result 到 output
                } else if (id === "5") {
                  this.outputFiveShow = true;
                  this.outputFive += parsedData.result
                      .replace(/[{}]/g, "")
                      .replace(/\*\*/g, "")
                      .replace(/['[]']/g, "")
                      .replace(/,/g, "")
                      .replace(/''/g, "")
                      .replace(/"/g, ""); // 追加 result 到 output
                } else if (id === "6") {
                  this.outputSix += parsedData.result
                      .replace(/[{}]/g, "")
                      .replace(/\*\*/g, "")
                      .replace(/['[]']/g, "")
                      .replace(/,/g, "")
                      .replace(/''/g, "")
                      .replace(/"/g, ""); // 追加 result 到 output
                }
              }
            } catch (error) {
              console.error("解析 JSON 时出错:", error);
            }
          });
        } else {
          // console.error("没有找到有效的 JSON 数据！");
        }
        // 保持滚动条在底部
        this.$nextTick(() => {
          const outputElement = document.getElementById("output");
          // outputElement.scrollTop = outputElement.scrollHeight;
        });
      }
      console.log("数据流结束");
    },

    changeStatus() {
      this.textShow = false;
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      } else {
        const controller = new AbortController();
        this.textShow = false;
        this.outputOne = "";
        this.outputThree = "";
        this.outputFour = "";
        this.outputFive = "";
        this.outputTwo = "";
        this.outputOneShow = "";
        this.outputThreeShow = "";
        this.outputFourShow = "";
        this.outputFiveShow = "";
        this.outputTwoShow = "";
      }
    },
    //知企通
    queryKnowledge() {
      this.htmlUrlNew = "",
      this.htmlUrl="";
      this.textShow=false;

      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });

      } else {
        this.isLoading = true;
        //调用获取行业分析
        this.getTextDetail(this.companyName)
        let str ="请基于全网公开数据（含政府公示信息）为" + this.companyName+"生成《科创全景分析报告》HTML文件，要求包含以下内容并采用视觉化设计：\n" +
            "\n" +
            "企业概况：用图标+1段话总结主营业务（如🏭科技服务）\n" +
            "行业地位：分3级描述（头部/腰部/新兴），并用对比柱状图展示市占率（需标注数据来源）\n" +
            "掌握技术：以标签云形式展示核心领域（标签大小代表技术成熟度）\n" +
            "知识产权：用双轴柱状图对比专利（如23项）与软著（如15项）数量\n" +
            "发展方向：分点列举3个未来增长点，每个点配1个行业趋势图标（如🚀）\n" +
            "技术需求：用优先级列表（高/中/低）展示5项创新技术需求\n" +
            "技术对接：列出3所省内高校（如XX大学）及对应技术领域，用院校徽标简笔画装饰\n" +
            "视觉要求：\n" +
            "宽度1200px居中，使用蓝色系主题色（#2A5CAA为主色）\n" +
            "图表高度≤300px，优先用SVG绘制（如无SVG可用HTML+CSS替代）\n" +
            "仅使用原生SVG/Canvas/D3.js（基础版）绘制图表（禁止使用ECharts/Chart.js等第三方库）\n"+
            "如果没有数据支撑可以不需要生成图\n" +
            "重点数据用加粗+变色（如#E63946）突出\n" +
            "交付完整HTML文件（无注释），所有资源内嵌，" +
            "不要出现下面的内容:以下是为您定制的xxx经营行业HTML分析报告。" +
            "该报告完全采用原生HTML、CSS与SVG技术构建，无任何第三方图表库依赖，" +
            "并严格遵守了您的设计规范与数据要求。只需要给我一个html\n"
        // let str ="请全网实时搜索，并且结合企查查和政府公开数据。" + this.companyName + "相关资料和信息,请以序号加标题，不要展示标题,格式返回给我，\n" +
        //     "    1、企业概况：整理总结下该公司目前的主营业务。\n" +
        //     "   2、行业地位：判断下企业当前经营情况，在该行业内的处于什么层次和地位。    3、掌握技术：企业目前拥有的技术都有哪些，请列举描述。\n" +
        //     "    4、知识产权：实时搜索查询，并结合企查查和政府官网公示的数据,查询一下 " + this.companyName + " 目前拥有的专利和软件著作权数量（如果没有搜索到可以使用接近的数量代替）分别多少( 注：需要展示具体的数量，如果没有搜索到可以使用接近的数量代替,不要出现企查查等字眼，要出现具体数量，不要出现替代符xxx之类的东西)。\n" +
        //     "    5、行业发展方向：企业要生存发展壮大的话，这些业务和产品未来发展有哪些好的方向，请详细列举和描述。\n" +
        //     "    6、技术需求挖掘：这些业务和产品要进行产业升级或降低成本来获得更好的市场份额和企业利润，那么企业有哪些技术需求，具有前瞻性的创新技性术需求目前都有哪些？请详细列举和描述。\n" +
        //     "    7、技术转移对接：如果企业需要对接拥有这些技术的团队，那这些技术分别对应哪些拥有这些技术的高校科研院所或企业，优先是省内重点高校也可以补充下当地的高校（要出现具体的大学名字），请详细列举和描述。\n" +
        //     "\" + \"请详细列举和描述。\n" +
        //     "\" + \"按照以上内容生成结果，有数据部分适当用柱状图或折线图等简单的图表,注意图表高度、宽度要适应网页大小，高度不超过500px, 没数据的就不用图表，不要有外部链接的图片，宽度1200居中，适当用主题色突出标题和重点部分，交付：提供完整HTML文件,不需要注释。"
        // let str = "请全网实时搜索，并且结合企查查和政府公开数据。" + this.companyName + "相关资料和信息,请以序号加标题，不要展示标题,格式返回给我，\n" +
        //     "1、企业概况：整理总结下该公司目前的主营业务。\n" +
        //     "2、行业地位：判断下企业当前经营情况，在该行业内的处于什么层次和地位。\n" +
        //     "3、掌握技术：企业目前拥有的技术都有哪些，请列举描述。\n" +
        //     "4、知识产权：实时搜索查询，并结合企查查和政府官网公示的数据,查询一下 " + this.companyName + " 目前拥有的专利和软件著作权数量（如果没有搜索到可以使用接近的数量代替）分别多少( 注：需要展示具体的数量，如果没有搜索到可以使用接近的数量代替,不要出现企查查等字眼，要出现具体数量，不要出现替代符xxx之类的东西)。\n" +
        //     "5、行业发展方向：企业要生存发展壮大的话，这些业务和产品未来发展有哪些好的方向，请详细列举和描述。\n" +
        //     "6、技术需求挖掘：这些业务和产品要进行产业升级或降低成本来获得更好的市场份额和企业利润，那么企业有哪些技术需求，具有前瞻性的创新技性术需求目前都有哪些？请详细列举和描述。\n" +
        //     "7、技术转移对接：如果企业需要对接拥有这些技术的团队，那这些技术分别对应哪些拥有这些技术的高校科研院所或企业，优先是省内重点高校也可以补充下当地的高校（要出现具体的大学名字），请详细列举和描述。" + "内容丰富生动 适当用柱状图或折线图等简单的可视化图表,不需要使用echarts图表，使用比较稳定的图表展示工具，注意图表样式规范高度不超过500px, 不要有外部链接的图片，页面效果美观宽度1200居中 适当用主题色突出标题和重点部分 交付：提供完整HTML文件,不需要注释。";
        getHtml({ concat: str.replaceAll("%", ""),stream:"false" }).then((res) => {
          console.log("res", res);
          if (res.code === 200) {
            this.htmlUrl = res.data;
            this.fetchIndustryChain()
          } else {
            this.$message({
              message: "请求失败",
              type: "error",
            });
          }
          this.isLoading = false;
          this.textShow = true;
        });
      }
    },


    //登录接口
    login() {
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      }
    },

    hisShowChange() {
      this.hisShow = false;
    },
    //跳转登录
    loginUp() {
      this.$router.push({path: "/login", query: {type: "2"}});
    },

    logout() {
      console.log("go");
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = true;
      this.$router.push({path: "/login", query: {type: "2"}});
      // var item = sessionStorage.getItem("token");
    },
    getToken() {
      if (localStorage.getItem("token")) {
        this.loginTrue = true;
        this.showPage = true;
      } else {
        this.loginTrue = false;
        // this.$router.push('/login')
      }
    },

    async fetchIndustryChain() {
      const token = localStorage.getItem('token')
      if (token == null) {
        this.$message({
          message: '您当前未登录账号，请登录或注册账号后进行查询',
          type: 'error',
          duration: 5000,
          showClose: true,
          offset: 200
        })
      }else {
        // 获取 userId
        const userId = localStorage.getItem("userId");

        // 先调用新增记录接口
        addZhiQiTongRecord({
          companyName: this.companyName,
          userId: userId
        }).then((addResponse) => {
          console.log("新增智启通记录成功", addResponse);
          // RuoYi 框架返回格式：response.data 才是实际数据
          const recordId = addResponse && (addResponse.data?.id || addResponse.id);
          console.log("获取到的recordId:", recordId);

          try {
            // 先展示容器，避免 G6 初始化时找不到 DOM
            this.isLoading = false;
            this.textShow = true;

            this.$nextTick(() => {
              derivativeDiagram(this.companyName).then((response) => {
                console.log("derivativeDiagram 响应:", response);
                if (response.code && response.code !== 200) {
                  this.$message.error("获取行业图谱失败: " + (response.msg || response.data || '未知错误'));
                  return;
                }
                this.initGraph(response.data);
              }).catch((err) => {
                console.error("derivativeDiagram 请求失败:", err);
                this.$message.error("获取行业图谱请求失败");
              });

              derivativeDiagramDown(this.companyName).then((response) => {
                console.log("derivativeDiagramDown 响应:", response);
                if (response.code && response.code !== 200) {
                  this.$message.error("获取技术图谱失败: " + (response.msg || response.data || '未知错误'));
                  return;
                }
                setTimeout(function () {
                  this.initGraphDown(response.data);
                }.bind(this), 200);

                // 数据加载完成后，调用更新记录接口，传入完成时间
                if (recordId) {
                  editZhiQiTongRecord({
                    id: recordId,
                    responseTime: new Date().getTime()
                  }).then((editResponse) => {
                    console.log("更新智启通记录响应:", editResponse);
                  }).catch((editError) => {
                    console.error("更新智启通记录失败", editError);
                  });
                }
              }).catch((err) => {
                console.error("derivativeDiagramDown 请求失败:", err);
                this.$message.error("获取技术图谱请求失败");
              });
            });
          } catch (error) {
            console.error("处理数据出错", error);
          }
        }).catch((addError) => {
          console.error("新增智启通记录失败", addError);
          // 即使新增记录失败，也继续执行主流程
          try {
            // 先展示容器，避免 G6 初始化时找不到 DOM
            this.isLoading = false;
            this.textShow = true;

            this.$nextTick(() => {
              derivativeDiagram(this.companyName).then((response) => {
                console.log("derivativeDiagram 响应:", response);
                if (response.code && response.code !== 200) {
                  this.$message.error("获取行业图谱失败: " + (response.msg || response.data || '未知错误'));
                  return;
                }
                this.initGraph(response.data);
              }).catch((err) => {
                console.error("derivativeDiagram 请求失败:", err);
                this.$message.error("获取行业图谱请求失败");
              });

              derivativeDiagramDown(this.companyName).then((response) => {
                console.log("derivativeDiagramDown 响应:", response);
                if (response.code && response.code !== 200) {
                  this.$message.error("获取技术图谱失败: " + (response.msg || response.data || '未知错误'));
                  return;
                }
                setTimeout(function () {
                  this.initGraphDown(response.data);
                }.bind(this), 200);
              }).catch((err) => {
                console.error("derivativeDiagramDown 请求失败:", err);
                this.$message.error("获取技术图谱请求失败");
              });
            });
          } catch (error) {
            console.error("处理数据出错", error);
          }
        });
      }
    },
    getTextDetail(item) {

      const query =
          "请为"+ this.companyName + "的核心经营行业生成HTML分析报告，" +
          "内容需包含：产业集群分布" +
          "全国主要聚集区域（文字描述+中国地图热力图）" +
          "示例数据标注：区域占比（如长三角35%、珠三角28%）" +
          "行业龙头企业5家知名企业（名称+核心优势/市占率）" +
          "营收规模对比柱状图（SVG绘制）" +
          "研究专家信息3位领域内权威专家（姓名+研究方向+所属机构）专家研究领域关键词标签云（SVG绘制）" +
          "设计规范：" +
          "如果没有数据支撑可以不需要生成图"+
          "宽度1200px居中，主题色#2A5CAA" +
          "图表高度≤300px，优先SVG" +
          "仅使用原生SVG/Canvas/D3.js（基础版）绘制图表（禁止使用ECharts/Chart.js等第三方库）"+
          "关键数据加粗变色" +
          "交付完整HTML文件。"
      console.log("item", item,query);
      getHtml({concat: query.replaceAll("%", "")}).then(res=>{
        if(res.code === 200){
          this.htmlUrlNew = res.data;
          this.loadingDown2 = false;
        }else{
          this.$message({
            message: "请求失败",
            type: "error",
          });
        }
      })
    },
    // changeStatus() {
    //   //销毁图标
    //   if (this.graph) {
    //     this.graph.destroy();
    //   }
    //   //把
    //   this.textShow = false;
    //   //把
    //   this.showGraph = false;
    // },

    initGraph(data) {
      // 如果图表已存在，先销毁
      // if (this.graph) {
      //   this.graph.destroy();
      // }

      // 如果没有数据，不初始化图表内容
      if (!data) return;

      // 获取 DOM 元素而非字符串 ID
      const containerEl = document.getElementById("containerHy");
      if (!containerEl) {
        console.error("找不到 containerHy DOM 元素");
        return;
      }

      // 判断节点属于上游/中游/下游：兼容 "upstream" / "upstream-1" / "up" / "up1" 等写法
      const stageOf = (id = "") => {
        const s = String(id).toLowerCase();
        if (s.includes("up") || s.includes("上游")) return "up";
        if (s.includes("mid") || s.includes("中游")) return "mid";
        if (s.includes("down") || s.includes("下游")) return "down";
        return "";
      };

      this.graph = new Graph({
        container: containerEl,
        autoFit: "view",
        padding: 100,
        data: treeToGraphData(data),
        node: {
          style: {
            size: (d) => {
              if (d.id === "root") return 100;
              if (d.depth === 1) return 60;
              return 20;
            },
            labelText: (d) => d.label,
            labelBackground: false,
            labelFontSize: (d) => {
              if (d.id === "root") return 24;
              if (d.depth === 1) return 15;
              return 16;
            },
            labelFill: "#000",
            labelPlacement: (d) => {
              if (d.id === "root" || d.depth === 1) return "center";
              const s = stageOf(d.id);
              if (s === "up") return "left";
              if (s === "down") return "right";
              return "top";
            },
            labelMaxWidth: 200,
            labelOffset: (d) => {
              if (d.id === "root" || d.depth === 1) return [0, 0];
              const s = stageOf(d.id);
              if (s === "up") return [-60, 0];
              if (s === "down") return [60, 0];
              return [0, -40];
            },
            fill: (d) => {
              if (d.id === "root") return "#8000ff";
              const s = stageOf(d.id);
              if (d.depth === 1) {
                return s === "up" ? "#4169e1" : s === "mid" ? "#00cca1" : "#cc33cc";
              }
              return s === "up" ? "#6495ed" : s === "mid" ? "#40e0d0" : "#da70d6";
            },
            stroke: "#fff",
            lineWidth: 2,
            // 添加自定义位置计算
            position: (d) => {
              if (d.depth === 1) {
                const radius = 150; // 上中下游节点到中心的距离
                const s = stageOf(d.id);
                let angle;
                if (s === "up") angle = -Math.PI / 2; // 上游在上方
                else if (s === "mid") angle = 0; // 中游在右方
                else angle = Math.PI / 2; // 下游在下方

                return {
                  x: Math.cos(angle) * radius,
                  y: Math.sin(angle) * radius,
                };
              }
              return undefined; // 其他节点使用默认布局
            },
          },
        },
        edge: {
          type: "cubic-radial",
          style: {
            lineWidth: 2,
            stroke: "#91d5ff",
            opacity: 0.6,
          },
        },
        layout: {
          type: "dendrogram",
          radial: true,
          preLayout: false,
          unitRadius: 300, // 增大半径
          preventOverlap: true,
          nodeSpacing: 100, // 增加节点间距
        },
        behaviors: [
          "drag-canvas",
          // 'zoom-canvas',
          "drag-element",
          {
            key: "hover-activate",
            type: "hover-activate",
            degree: 5,
            direction: "in",
            inactiveState: "inactive",
          },
        ],
        transforms: [],
        animation: false,
      });

      this.graph.render();
      this.loading = false;
    },

    // 为将来可能接收props更改添加watch
    // watch: {
    //   industryName(newVal) {
    //     if (newVal) {
    //       this.industry = newVal;
    //       this.fetchIndustryChain();
    //     }
    //   }
    // }
    initGraphDown(data) {
      // 如果图表已存在，先销毁
      // if (this.graph) {
      //   this.graph.destroy();
      // }

      // 如果没有数据，不初始化图表内容
      if (!data) return;

      // 获取 DOM 元素而非字符串 ID
      const containerEl = document.getElementById("containerDown");
      if (!containerEl) {
        console.error("找不到 containerDown DOM 元素");
        return;
      }

      // 判断节点属于上游/中游/下游：兼容 "upstream" / "upstream-1" / "up" / "up1" 等写法
      const stageOf = (id = "") => {
        const s = String(id).toLowerCase();
        if (s.includes("up") || s.includes("上游")) return "up";
        if (s.includes("mid") || s.includes("中游")) return "mid";
        if (s.includes("down") || s.includes("下游")) return "down";
        return "";
      };

      this.graph = new Graph({
        container: containerEl,
        autoFit: "view",
        padding: 100,
        data: treeToGraphData(data),
        node: {
          style: {
            size: (d) => {
              if (d.id === "root") return 100;
              if (d.depth === 1) return 60;
              return 20;
            },
            labelText: (d) => d.label,
            labelBackground: false,
            labelFontSize: (d) => {
              if (d.id === "root") return 24;
              if (d.depth === 1) return 15;
              return 16;
            },
            labelFill: "#000",
            labelPlacement: (d) => {
              if (d.id === "root" || d.depth === 1) return "center";
              const s = stageOf(d.id);
              if (s === "up") return "left";
              if (s === "down") return "right";
              return "top";
            },
            labelMaxWidth: 200,
            labelOffset: (d) => {
              if (d.id === "root" || d.depth === 1) return [0, 0];
              const s = stageOf(d.id);
              if (s === "up") return [-60, 0];
              if (s === "down") return [60, 0];
              return [0, -40];
            },

            fill: (d) => {
              if (d.id === "root") return "#8000ff";
              const s = stageOf(d.id);
              if (d.depth === 1) {
                return s === "up" ? "#4169e1" : s === "mid" ? "#00cca1" : "#cc33cc";
              }
              return s === "up" ? "#6495ed" : s === "mid" ? "#40e0d0" : "#da70d6";
            },

            stroke: "#fff",
            lineWidth: 2,
            // 添加自定义位置计算
            position: (d) => {
              if (d.depth === 1) {
                const radius = 150; // 上中下游节点到中心的距离
                const s = stageOf(d.id);
                let angle;
                if (s === "up") angle = -Math.PI / 2; // 上游在上方
                else if (s === "mid") angle = 0; // 中游在右方
                else angle = Math.PI / 2; // 下游在下方

                return {
                  x: Math.cos(angle) * radius,
                  y: Math.sin(angle) * radius,
                };
              }
              return undefined; // 其他节点使用默认布局
            },
          },
        },
        edge: {
          type: "cubic-radial",
          style: {
            lineWidth: 2,
            stroke: "#91d5ff",
            opacity: 0.6,
          },
        },

        layout: {
          type: "dendrogram",
          radial: true,
          preLayout: false,
          unitRadius: 300, // 增大半径
          preventOverlap: true,
          nodeSpacing: 100, // 增加节点间距
        },

        behaviors: [
          "drag-canvas",
          // 'zoom-canvas',
          "drag-element",
          {
            key: "hover-activate",
            type: "hover-activate",
            degree: 5,
            direction: "in",
            inactiveState: "inactive",
          },
        ],

        transforms: [],
        animation: false,
      });
      this.graph.render();
      this.loadingDown = false;
    },

  },
};
</script>

<style scoped lang="scss">
.fade-in {
  animation: fadeIn 0.8s ease-in-out forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.loadingGif {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.classLabe2 {
  display: flex;

  .labe2Right {
    margin-left: 270px;
  }
}

::v-deep .bold-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px !important;
}

//加载中
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 遮罩层在最上面 */
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #0077ff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

/* 加载动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载文本样式 */
.loading-text {
  color: #ffffff;
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}

//数据处理样式
.content {
  white-space: pre-line; /* 保留换行符 */
  text-align: left;
  font-size: 20px;
}

.queryButton {
  width: 200px;
  font-size: 20px;
  margin-top: 30px;
}

.form-row {
  display: flex;
  align-items: center;
}

.form-row span {
  margin-right: 10px;
  width: 20%;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
  font-size: 22px;
}

.selectedForm {
  width: 200px;
}

.formSelectDiv {
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
}

.label {
  margin-right: 10px; /* 控制文本和选择框之间的间距 */
}

.selectClass {
  padding: 5px;
  border: 1px solid #ccc;
  width: 500px;
  font-size: 20px;
}

.bord {
  margin: 90px auto 120px;
  padding: 20px;
  max-width: 1200px;
  min-height: 300px;
  height: auto;
  border: 1px solid rgba(0, 119, 255, 0.12);
  text-align: center;
  transition: all 0.3s ease;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 119, 255, 0.08), 0 2px 10px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;

  .spanFront {
    margin-bottom: 20px;
    font-size: 20px;
    text-align: center;
  }

  .formSelect {
    font-size: 20px !important;
  }
}

.bord:hover {
  box-shadow: 0 30px 80px rgba(0, 119, 255, 0.12), 0 6px 18px rgba(0, 0, 0, 0.08);
}

.bord > * {
  position: relative;
  z-index: 1;
}

::v-deep .subClass {
  color: #fff !important;
  background-color: #0077ff !important;
}

.closeClass {
  color: #fff;
  background-color: #ff4d4f;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
  //text-decoration: underline;
}

.bannerBox {
  width: 100%;
}

.layout {
  width: 100%;
}

::v-deep .layout {
  display: flex;
}

.banner_box {
  height: 500px;
}

.banner_box .ban_top .right .no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.banner_box .ban_top .left img {
  width: 176px;
}

.img {
  max-width: 100%;
  border: none;
}

.banner_box .ban_top .left .div2 {
  position: relative;
  margin: 0 40px 0 80px;
  padding: 12px 20px;
  border-radius: 23px;
}

.banner_box {
  background-image: url("../assets/img/zhiqitong.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 24px 0 190px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-around;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.banner_box .ban_text {
  margin: 100px 0 43px;
  font-weight: 600;
  font-size: 54px;
  color: #fff;
  line-height: 71px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  flex: none;
}

.banner_box .btn1,
.banner_box .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.ban_btn {
  margin-top: 410px;
}

.banner_box .ban_btn .btn1 {
  border-radius: 30px;
  border: 2px solid #fff;
  color: #fff;
}

.banner_box .ban_btn .btn2 {
  border-radius: 30px;
  background: #fff;
  color: #333;
}

.banner_box .ban_btn .btn1,
.banner_box .ban_btn .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  margin-right: 50px;
}

.banner_box .ban_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box .step,
.step_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box {
  background: #f7f7f7;
  padding: 90px 0 100px;
}

.step_box .step .step_top {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
}

.step_box .step .step_lab {
  margin-top: 26px;
  font-weight: 400;
  font-size: 20px;
  color: #606266;
  line-height: 27px;
}

.step_box .step .step_itm {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.page_width {
  width: 1200px;
  margin-top: 100px;
}

.step_box .step {
  flex-direction: column;
}

.step_box .step .step_itm .itm_box .num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  color: #2238c2;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 2px solid #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 27px;
  width: 15%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 40px;
  width: 10%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit span {
  color: #2238c2;
}

.reason_box .reason .cont .cont_itm {
  margin-left: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 385px;
  height: 286px;
  padding: 62px 53px 0;
  box-sizing: border-box;
  background: #f5fbfc;
  border-radius: 12px;
  font-size: 16px;
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exchange_box .exchange .ex_left .tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  margin-bottom: 50px;
}

.exchange_box .exchange .ex_left .tit span {
  color: #2238c2;
}

.exchange_box .exchange .ex_left {
  width: 75%;
}

.exchange_box .exchange .ex_left .itm img {
  width: 24px;
  height: 24px;
  margin-right: 14px;
  font-size: 16px;
}

img {
  max-width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange .ex_left .itm {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  font-size: 16px;
}

.exchange_box {
  padding: 84px 0 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/img/lineImg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

img {
  width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.website {
  padding: 30px 0;
  background: #252525;
  justify-content: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
  color: #a8a8a8;
  background: #252525;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
  line-height: 1.6;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.logo {
  cursor: pointer;
  background-image: url("~@/assets/img/logn.png");
  background-size: 450px 70px;
  width: 450px;
  height: 70px;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  position: relative;
}

.view-count-inline {
  display: inline-flex;
  align-items: center;
  margin-left: 16px;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(168, 168, 168, 0.6);
  font-size: 12px;
  color: #d0d0d0;

  i {
    font-size: 14px;
    margin-right: 4px;
  }
}

.problem_box {
  width: 100%;
  background: #fff;
  padding: 90px 0 131px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.problem_box_inline {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 131px;
}

.problem_box_inline .pro_tit span {
  color: #009eb8;
}

.problem_box_inline .pro_tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
  text-align: center;
  margin-bottom: 80px;
}

.problem_box_inline .pro_lab {
  font-weight: 700;
  margin-bottom: 13px;
  font-size: 20px;
  color: #333;
}

.problem_box_inline .pro_cont {
  font-weight: 400;
  font-size: 16px;
  color: #666;
  line-height: 28px;
}

.mb40 {
  margin-bottom: 40px;
}

.form-container {
  max-width: 1200px;
  margin: 90px auto 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.steps {
  display: flex;
  justify-content: space-between;

  position: relative;
  padding: 0 40px;
  margin-top: 30px;
  margin-bottom: 60px;
}

.step {
  display: flex;
  align-items: center;
  z-index: 1;
}

.step-number {
  width: 24px;
  height: 24px;
  background: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 14px;
}

.step-text {
  font-size: 20px;
}

.step::after {
  content: "";
  display: inline-block;
  width: 127px;
  height: 1px;
  z-index: 0;
  margin-left: 6px;
}

.steps .step:last-child:after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  background: #e8e8e8;
  z-index: 0;
  margin-left: 0;
}

.form-row {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 22px;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 20px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
}

.file-upload {
  border: 1px dashed #d9d9d9;
  padding: 20px;
  text-align: center;
  background: #fafafa;
  border-radius: 4px;
}

.upload-button {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.file-info {
  font-size: 22px;
  color: #666;
  margin-top: 12px;
}

.file-types {
  font-size: 22px;
  color: #666;
  margin-top: 8px;
}

.form-containerquery {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.file-types {
  font-size: 20px;
  color: #666;
  margin-bottom: 20px;
}

.certificate-type {
  border: 1px solid #e8e8e8;
  padding: 15px;
  margin-bottom: 20px;
}

.certificate-warning {
  color: #ff4d4f;
  font-size: 12px;
  margin-bottom: 10px;
}

.certificate-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.certificate-option {
  border: 1px solid #e8e8e8;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.certificate-option:hover {
  border-color: #40a9ff;
}

.certificate-option.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

.certificate-option img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.rights-section {
  margin-bottom: 20px;
}

.rights-grid {
  width: 90%;
  margin: 0 auto;

  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.right-option {
  width: 25%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

.agreement {
  display: flex;
  align-items: center;

  margin-bottom: 20px;
  justify-content: center;

  input {
    width: 16px;
    height: 16px;
  }
}

.agreement a {
  color: #1890ff;
  text-decoration: none;
}

.submit-buttonLeft {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 25%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-buttonRight {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 10%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-button {
}

.submit-button:hover {
  background: #40a9ff;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.cha_xun {
  padding: 3.5rem 18.33rem 10.42rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tips {
    font-size: 1.33rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #232323;
    line-height: 2.25rem;
  }
}

.cha_xun .tips {
  margin-top: 2.08rem;
  padding: 0.92rem 1.92rem 3.25rem;
  background: rgba(39, 130, 255, 0.1);
  border: 1px solid #2782ff;
  border-radius: 0.25rem;
  display: flex;
  align-items: baseline;
}

.cha_xun .tips div[data-v-71571416] {
  font-size: 1.33rem;
  font-weight: 400;
  color: #232323;
  line-height: 2.25rem;
  font-size: 20px;
}

.cha_xun .input_box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cha_xun .file_hash[data-v-71571416],
.cha_xun .unified_numbering[data-v-71571416] {
  display: flex;
  align-items: center;
  margin-top: 4.25rem;
}

.cha_xun .file_hash .el-input[data-v-71571416] .el-input__inner,
.cha_xun .unified_numbering .el-input[data-v-71571416] .el-input__inner {
  border-radius: 0.25rem;
  font-size: 1.4rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.cha_xun .query[data-v-71571416] {
  cursor: pointer;
  margin-top: 5.67rem;
  padding: 1.17rem 10rem;
  display: inline-block;
  background: #2782ff;
  box-shadow: 0 0.3rem 3rem 0 rgba(29, 62, 187, 0.2);
  border-radius: 0.25rem;
  font-size: 1.67rem;
  font-weight: 700;
  color: #fff;
  line-height: 2rem;
}

.me {
  max-width: 1200px;
  height: auto;
  margin: 90px auto 90px;
  padding: 20px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .labe2 {
  font-size: 16px;
}

.no_loginLeft {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.no_loginRight {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 20px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
  margin-left: 10px;
}

.el-dropdownClass {
  width: 50%;
}

.dataclass {
  font-size: 20px;
}

.submitClass {
  display: flex;
}

.el-textarea .el-input__count {
  margin-bottom: 10px !important;
}

.right-optionValue {
  width: 30%;
  display: flex;
  align-items: center;

  font-size: 20px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}
.containerDownSpan {
  display: flex;
  font-size: 20px;
}

.containerSpan {
  display: flex;
  font-size: 20px;
}
.graph-container {
  width: 100%;
  height: 100%;
}

.zqt-page {
  position: relative;
  background-color: #fff;
  font-size: 16px;
  line-height: 1.7;
}

@keyframes zqtSheen {
  0% {
    transform: translateX(-70%) skewX(-12deg);
  }
  100% {
    transform: translateX(70%) skewX(-12deg);
  }
}

.zqt-dashboard {
  width: 100%;
}

.zqt-stats {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin-bottom: 60px;

  .zqt-stat {
    text-align: center;

    &-value {
      font-size: 40px;
      font-weight: bold;
      color: #0077ff;
      margin-bottom: 8px;
    }

    &-label {
      font-size: 18px;
      color: #909399;
    }
  }
}

.zqt-section-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;

  &-text {
    font-size: 32px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 12px;
  }

  &-line {
    width: 60px;
    height: 4px;
    background: #0077ff;
    border-radius: 2px;
  }

  &--mt {
    margin-top: 60px;
  }
}

.zqt-cards {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 60px;

  .zqt-card {
    flex: 1;
    background: rgba(255, 255, 255, 0.78);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: 14px;
    padding: 32px 24px;
    box-shadow: 0 14px 40px rgba(0, 119, 255, 0.06);
    transition: transform 0.28s ease, box-shadow 0.28s ease;
    border: 1px solid rgba(0, 119, 255, 0.10);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      inset: -2px;
      background: linear-gradient(120deg, rgba(0, 119, 255, 0), rgba(0, 119, 255, 0.16), rgba(34, 211, 238, 0.12), rgba(0, 119, 255, 0));
      transform: translateX(-60%);
      opacity: 0;
      pointer-events: none;
    }

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 22px 60px rgba(0, 119, 255, 0.12);
    }

    &:hover::before {
      opacity: 1;
      animation: zqtSheen 1.6s ease forwards;
    }

    &-icon {
      width: 56px;
      height: 56px;
      background: #0077ff;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;

      i {
        font-size: 28px;
        color: #fff;
      }
    }

    &-title {
      font-size: 22px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 16px;
    }

    &-desc {
      font-size: 15px;
      color: #606266;
      line-height: 1.6;
      margin-bottom: 24px;
      min-height: 68px;
    }

    &-metrics {
      width: 100%;
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #f2f6fc;
      padding-top: 20px;

      .zqt-metric {
        &-value {
          font-size: 20px;
          font-weight: bold;
          color: #0077ff;
          margin-bottom: 4px;
        }

        &-label {
          font-size: 13px;
          color: #909399;
        }
      }
    }
  }
}

.zqt-scenarios {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 64px;

  .zqt-scenario-card {
    background: #ffffff;
    border-radius: 14px;
    padding: 24px 22px 26px;
    box-shadow: 0 16px 46px rgba(0, 0, 0, 0.04);
    border: 1px solid #eef2f7;
    text-align: left;
    transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 22px 60px rgba(0, 119, 255, 0.12);
      border-color: rgba(0, 119, 255, 0.35);
    }

    .zqt-scenario-tag {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 999px;
      background: rgba(0, 119, 255, 0.06);
      color: #0077ff;
      font-size: 14px;
      margin-bottom: 12px;
      font-weight: 600;
    }

    .zqt-scenario-title {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 10px;
    }

    .zqt-scenario-desc {
      font-size: 14px;
      color: #606266;
      line-height: 1.7;
      margin-bottom: 12px;
    }

    .zqt-scenario-list {
      padding-left: 18px;
      margin: 0;
      list-style: disc;

      li {
        font-size: 14px;
        color: #4a4a4a;
        line-height: 1.7;
        margin-bottom: 4px;
      }
    }
  }
}

.zqt-flow {
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 18px;
  margin-bottom: 64px;

  .zqt-flow-step {
    flex: 1;
    background: #ffffff;
    border-radius: 14px;
    padding: 20px 18px 22px;
    text-align: left;
    box-shadow: 0 10px 32px rgba(0, 0, 0, 0.04);
    border: 1px solid #eef2f7;
    position: relative;

    .zqt-flow-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: linear-gradient(135deg, #0077ff, #00a3ff);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-weight: 700;
      font-size: 18px;
      margin-bottom: 12px;
    }

    .zqt-flow-title {
      font-size: 17px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 8px;
    }

    .zqt-flow-desc {
      font-size: 14px;
      color: #606266;
      line-height: 1.7;
    }
  }

  .zqt-flow-arrow {
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: "";
      width: 18px;
      height: 18px;
      border-right: 2px solid #c0c4cc;
      border-bottom: 2px solid #c0c4cc;
      transform: rotate(-45deg);
    }
  }
}

.zqt-security {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 80px;

  .zqt-security-item {
    background: #f7f9fc;
    border-radius: 12px;
    padding: 20px 18px 22px;
    border: 1px solid #e3ebf5;
    text-align: left;

    .zqt-security-title {
      font-size: 17px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 10px;
    }

    .zqt-security-desc {
      font-size: 14px;
      color: #606266;
      line-height: 1.8;
    }
  }
}

.zqt-search {
  background: #fff;
  border-radius: 16px;
  padding: 52px 56px;
  box-shadow: 0 20px 50px rgba(0, 119, 255, 0.08);
  max-width: 900px;
  margin: 0 auto;

  &-title {
    font-size: 26px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 12px;
  }

  &-subtitle {
    font-size: 16px;
    color: #909399;
    margin-bottom: 40px;
  }

  &-form {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .zqt-field {
      text-align: left;

      &-label {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        color: #303133;
        font-weight: bold;

        i {
          color: #0077ff;
        }
      }

      ::v-deep .el-input__inner {
        height: 50px;
        line-height: 50px;
        border-radius: 8px;
        background: #f5f7fa;
        border: 1px solid transparent;

        &:focus {
          border-color: #0077ff;
          background: #fff;
        }
      }
    }

    .zqt-search-btn {
      height: 54px;
      font-size: 18px;
      font-weight: bold;
      border-radius: 8px;
      background: linear-gradient(90deg, #0077ff 0%, #00a3ff 100%);
      border: none;
      margin-top: 12px;
      box-shadow: 0 10px 20px rgba(0, 119, 255, 0.2);

      &:hover {
        opacity: 0.9;
        transform: translateY(-2px);
      }
    }

    .zqt-actions {
      display: flex;
      justify-content: center;
      gap: 12px;
      margin-top: 24px;

      .zqt-action {
        border-radius: 20px;
        padding: 8px 20px;
        color: #0077ff;
        border-color: #0077ff;

        &:hover {
          background: #0077ff;
          color: #fff;
        }
      }
    }
  }
}
.containerHy {
  width: 100%;
  height: 80vh;
  background: #ffffff;
  position: relative;
}
.containerDown {
  width: 100%;
  height: 80vh;
  background: #ffffff;
  position: relative;
}
.graph-container {
  width: 100%;
  height: 100%;
}
</style>
